export class SubcategoryDetails {
    date:Date;
    category :string;
    subcategory: string;
    todayActual: string;
    todayBudget: string;
    todayLastYear: string;
    todayVob: string;
    todayVoly: string;
    mtdActual: string;
    mtdBudget: string;
    mtdLastYear: string;
    mtdVob: string;
    mtdVoly: string;
    ytdActual: string;
    ytdBudget: string;
    ytdLastYear : string;
    ytdVob: string;
    ytdVoly: string;
  subcategoryName: string;
    constructor(date:Date,category :string,subcategory: string, todayActual: string, todayBudget: string, todayLastYear: string, todayVob: string, todayVoly: string, mtdActual: string, mtdBudget: string, mtdLastYear: string, mtdVob: string, mtdVoly: string, ytdActual: string, ytdBudget: string, ytdLastYear: string, ytdVob: string, ytdVoly: string,) {
        this.date = date;
        this.category = category;
        this.subcategory = subcategory;
        this.todayActual = todayActual;
        this.todayBudget = todayBudget;
        this.todayLastYear = todayLastYear;
        this.todayVob = todayVob;
        this.todayVoly = todayVoly;
        this.mtdActual = mtdActual;
        this.mtdBudget = mtdBudget;
        this.mtdLastYear = mtdLastYear;
        this.mtdVob = mtdVob;
        this.mtdVoly = mtdVoly;
        this.ytdActual = ytdActual;
        this.ytdBudget = ytdBudget;
        this.ytdLastYear = ytdLastYear;
        this.ytdVob = ytdVob;
        this.ytdVoly = ytdVoly;

    }
}